import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Apple = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.275 1.916c.135 1.23-.36 2.464-1.093 3.353-.735.887-1.937 1.578-3.115 1.487-.16-1.208.435-2.462 1.114-3.25.759-.888 2.038-1.547 3.094-1.59m3.802 7.17c-.227.14-2.276 1.418-2.25 3.989.027 3.103 2.66 4.183 2.81 4.244l.007.003-.008.025c-.066.21-.491 1.565-1.447 2.962-.875 1.28-1.782 2.553-3.213 2.579-.687.013-1.147-.186-1.625-.393-.5-.216-1.02-.44-1.842-.44-.862 0-1.406.231-1.93.454-.454.194-.893.381-1.51.406-1.381.052-2.433-1.382-3.316-2.657C3.95 17.651 2.57 12.89 4.423 9.676 5.34 8.08 6.984 7.07 8.767 7.043c.769-.014 1.513.282 2.165.54.498.198.941.375 1.3.375.322 0 .754-.17 1.258-.37.793-.312 1.763-.695 2.763-.593.684.028 2.607.275 3.84 2.08z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.275 1.916c.135 1.23-.36 2.464-1.093 3.353-.735.887-1.937 1.578-3.115 1.487-.16-1.208.435-2.462 1.114-3.25.759-.888 2.038-1.547 3.094-1.59m3.802 7.17c-.227.14-2.276 1.418-2.25 3.989.027 3.103 2.66 4.183 2.81 4.244l.007.003-.008.025c-.066.21-.491 1.565-1.447 2.962-.875 1.28-1.782 2.553-3.213 2.579-.687.013-1.147-.186-1.625-.393-.5-.216-1.02-.44-1.842-.44-.862 0-1.406.231-1.93.454-.454.194-.893.381-1.51.406-1.381.052-2.433-1.382-3.316-2.657C3.95 17.651 2.57 12.89 4.423 9.676 5.34 8.08 6.984 7.07 8.767 7.043c.769-.014 1.513.282 2.165.54.498.198.941.375 1.3.375.322 0 .754-.17 1.258-.37.793-.312 1.763-.695 2.763-.593.684.028 2.607.275 3.84 2.08z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
